import { render } from "./UserInfoSetting.vue?vue&type=template&id=2662d99d"
import script from "./UserInfoSetting.vue?vue&type=script&lang=js"
export * from "./UserInfoSetting.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/workspace/xujiaxin-linchuang-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__